export const Organization: React.FC = (props) => {
  const { children } = props;
  return (
    <span style={{ fontWeight: 'bold', color: '#28A0CB' }}>
      {children || 'ORGANIZATION'}
    </span>
  );
};

export const AssociatedEntity: React.FC = (props) => {
  const { children } = props;
  return (
    <span style={{ fontWeight: 'bold', color: '#4D8055' }}>
      {children || 'ASSOCIATED ENTITY'}
    </span>
  );
};
